<template>
	<div class="">
		<el-card class="box-card" v-if="UserInfo.registerIdentity === 1">
			<div slot="header" class="flex-be">
				<span>账号信息</span>
				<div>
					<el-button type="text" @click="editTag = true">编辑</el-button>
					<el-button type="text" @click="resetPasswordDialog = true">重置密码</el-button>
				</div>
			</div>
			<div class="content_table m-b-20" v-loading="loading">
				<el-descriptions :title="(userName || '用户') + '信息'" :column="3">
					<!-- <el-descriptions-item label="当前头像" :span="3">
            <el-image class="" style="width: 100px; height: 100px" :src="UserInfo.avatar || ''"
              :preview-src-list="[UserInfo.avatar] || []">
              <div slot="error" class="image-slot">
                暂无图片
              </div>
            </el-image>
            <el-upload v-if="editTag" class="avatar-uploader" :action="this.$const.common.fileUpload" :show-file-list="false" :before-upload="beforeAvatarUpload" :on-success="upLoadFileSuccess" :on-error="upLoadFileError">
              <el-button size="small" class="f_picture">重新上传</el-button>
            </el-upload>
          </el-descriptions-item> -->
					<!-- <el-descriptions-item label="账号类型">
            <span>{{ accountType[UserInfo.registerIdentity] }}</span> -->
					<!-- <span v-if="UserInfo.registerIdentity==1 && !editTag" @click="changeRegister" style="color: #409eff;margin-left: 20px;cursor: pointer;">升级企业认证</span> -->
					<!-- </el-descriptions-item> -->

					<el-descriptions-item label="用户名">
						<span v-if="!editTag">{{ UserInfo.userName || '--' }}</span>
						<el-input v-if="editTag" v-model="UserInfo.userName" placeholder="请输入名称" disabled></el-input>
					</el-descriptions-item>

					<el-descriptions-item label="用户姓名">
						<span v-if="!editTag">{{ UserInfo.nickName || '--' }}</span>
						<el-input v-if="editTag" v-model="UserInfo.nickName" placeholder="请输入用户昵称"></el-input>
					</el-descriptions-item>

					<el-descriptions-item label="邮箱地址" v-if="UserInfo.registerIdentity === 1">
						<span v-if="!editTag">{{ UserInfo.email || '--' }}</span>
						<el-input v-if="editTag" v-model="UserInfo.email" placeholder="请输入邮箱"></el-input>
					</el-descriptions-item>
					<el-descriptions-item label="手机号码">
						<span v-if="!editTag">{{ UserInfo.phoneNumber || '--' }}</span>
						<el-input v-if="editTag" v-model="UserInfo.phoneNumber" placeholder="请输入注册手机号"></el-input>
						<!-- <span v-if="!editTag" @click="changePhoneDialog=true" style="color: #409eff;margin-left: 20px;cursor: pointer;">更改手机号</span> -->
					</el-descriptions-item>
					<!-- <el-descriptions-item label="所在地">
						<span v-if="!editTag">{{ UserInfo.provinceName || '--' }}</span>
						<el-select @change="provinceSelect" v-if="editTag" v-model="UserInfo.provinceCode" placeholder="请选择所在地" style="width: 150px; margin-right: 10px">
							<el-option :label="item.name" :value="item.adminCode" v-for="item in provinceOptions"></el-option>
						</el-select>
						<el-select @change="citySelect" v-if="editTag" v-model="UserInfo.cityCode" placeholder="请选择所在地" style="width: 70px">
							<el-option :label="item.name" :value="item.adminCode" v-for="item in cityOptions"></el-option>
						</el-select>
					</el-descriptions-item> -->
					<!-- <el-descriptions-item label="应用领域">
						<span v-if="!editTag">{{ UserInfo.industry || '--' }}</span>
						<el-select v-if="editTag" v-model="UserInfo.industry" placeholder="请选择应用领域">
							<el-option label="农业" value="农业"></el-option>
							<el-option label="林业" value="林业"></el-option>
							<el-option label="环境" value="环境"></el-option>
							<el-option label="水利" value="水利"></el-option>
							<el-option label="气象" value="气象"></el-option>
							<el-option label="国土" value="国土"></el-option>
							<el-option label="海洋" value="海洋"></el-option>
							<el-option label="城市" value="城市"></el-option>
							<el-option label="教育" value="教育"></el-option>
							<el-option label="科研" value="科研"></el-option>
							<el-option label="矿业" value="矿业"></el-option>
							<el-option label="地矿" value="地矿"></el-option>
							<el-option label="灾害" value="灾害"></el-option>
							<el-option label="其他" value="其他"></el-option>
						</el-select>
					</el-descriptions-item> -->

					<el-descriptions-item label="单位全称">
						<span v-if="!editTag">{{ UserInfo.company || '--' }}</span>
						<el-input v-if="editTag" v-model="UserInfo.company" placeholder="请输入单位名称"></el-input>
					</el-descriptions-item>
					<el-descriptions-item label="身份证号">
						<span v-if="!editTag">{{ UserInfo.identityCard || '--' }}</span>
						<el-input v-if="editTag" v-model="UserInfo.identityCard" placeholder="请输入身份证号"></el-input>
					</el-descriptions-item>
					<!-- <el-descriptions-item label="单位地址">
						<span v-if="!editTag">{{ UserInfo.companyAddress || '--' }}</span>
						<el-input v-if="editTag" v-model="UserInfo.companyAddress" placeholder="请输入单位地址"></el-input>
					</el-descriptions-item>
					<el-descriptions-item label="单位信用代码">
						<span v-if="!editTag">{{ UserInfo.organizationCode || '--' }}</span>
						<el-input v-if="editTag" v-model="UserInfo.organizationCode" placeholder="请输入社会信用代码"></el-input>
					</el-descriptions-item>
					<el-descriptions-item label="单位性质">
						<span v-if="!editTag">{{ UserInfo.companyNature || '--' }}</span>
						<el-select v-if="editTag" v-model="UserInfo.companyNature" placeholder="请选择单位性质">
							<el-option :label="item.label" :value="item.value" v-for="(item, i) in companyNatureList"></el-option>
						</el-select>
					</el-descriptions-item> -->
				</el-descriptions>
			</div>

			<div class="card_footer m-t-20" v-if="editTag">
				<el-button size="small" type="primary" @click="saveUserInfo()">保 存</el-button>
				<el-button size="small" @click="cancel()">取 消</el-button>
			</div>
		</el-card>

		<el-card class="box-card" v-else>
			<div slot="header" class="flex-be">
				<span>账号信息</span>
				<div>
					<el-button type="text" @click="editTag = true">编辑</el-button>
					<el-button type="text" @click="resetPasswordDialog = true">重置密码</el-button>
				</div>
			</div>
			<div class="content_table m-b-20" v-loading="loading">
				<el-descriptions :title="'亲爱的 ' + (userName || '用户') + '，请填写真实资料'" :column="3">
					<el-descriptions-item label="当前头像" :span="3">
						<el-image class="" style="width: 100px; height: 100px" :src="UserInfo.portrait || ''" :preview-src-list="[UserInfo.portrait] || []">
							<div slot="error" class="image-slot">暂无图片</div>
						</el-image>
						<el-upload
							v-if="editTag"
							class="avatar-uploader"
							:action="this.$const.common.fileUpload"
							:show-file-list="false"
							:before-upload="beforeAvatarUpload"
							:on-success="upLoadFileSuccess"
							:on-error="upLoadFileError"
						>
							<el-button size="small" class="f_picture">重新上传</el-button>
						</el-upload>
					</el-descriptions-item>
					<!-- <el-descriptions-item label="账号类型">
            <span>{{ accountType[UserInfo.registerIdentity] }}</span>
            <span v-if="UserInfo.registerIdentity == 1"
              style="color: #409eff;margin-left: 20px;cursor: pointer;">升级企业认证</span>
          </el-descriptions-item> -->
					<el-descriptions-item label="用户名称">
						<span v-if="!editTag">{{ UserInfo.userName || '--' }}</span>
						<el-input v-if="editTag" v-model="UserInfo.userName" placeholder="请输入用户名" disabled></el-input>
					</el-descriptions-item>

					<el-descriptions-item label="用户昵称">
						<span v-if="!editTag">{{ UserInfo.realName || '--' }}</span>
						<el-input v-if="editTag" v-model="UserInfo.realName" placeholder="请输入昵称"></el-input>
					</el-descriptions-item>

					<el-descriptions-item label="邮箱地址" v-if="UserInfo.registerIdentity === 1">
						<span v-if="!editTag">{{ UserInfo.email || '--' }}</span>
						<el-input v-if="editTag" v-model="UserInfo.email" placeholder="请输入邮箱"></el-input>
					</el-descriptions-item>
					<el-descriptions-item label="手机号码">
						<span v-if="!editTag">{{ UserInfo.phoneNumber || '--' }}</span>
						<el-input v-if="editTag" v-model="UserInfo.phoneNumber" placeholder="请输入注册手机号" disabled></el-input>
						<span v-if="!editTag" @click="changePhoneDialog = true" style="color: #409eff; margin-left: 20px; cursor: pointer">更改手机号</span>
					</el-descriptions-item>
					<el-descriptions-item label="公司名称" v-if="UserInfo.registerIdentity === 2">
						<span v-if="!editTag">{{ UserInfo.companyName || '--' }}</span>
						<el-input v-if="editTag" v-model="UserInfo.companyName" placeholder="请输入公司名称"></el-input>
					</el-descriptions-item>
					<template v-if="UserInfo.registerIdentity === 3">
						<el-descriptions-item label="机构名称">
							<span v-if="!editTag">{{ UserInfo.organizationName || '--' }}</span>
							<el-input v-if="editTag" v-model="UserInfo.organizationName" placeholder="请输入机构名称"></el-input>
						</el-descriptions-item>
						<el-descriptions-item label="机构地址">
							<span v-if="!editTag">{{ UserInfo.organizationAddress || '--' }}</span>
							<el-input v-if="editTag" v-model="UserInfo.organizationAddress" placeholder="请输入机构地址"></el-input>
						</el-descriptions-item>
						<el-descriptions-item label="机构号码">
							<span v-if="!editTag">{{ UserInfo.organizationCode || '--' }}</span>
							<el-input v-if="editTag" v-model="UserInfo.organizationCode" placeholder="请输入机构码"></el-input>
						</el-descriptions-item>
					</template>
					<el-descriptions-item label="信用代码" v-if="UserInfo.registerIdentity === 2">
						<span v-if="!editTag">{{ UserInfo.companyLicenseCode || '--' }}</span>
						<el-input v-if="editTag" v-model="UserInfo.companyLicenseCode" placeholder="请输入统一社会信用代码"></el-input>
					</el-descriptions-item>
				</el-descriptions>
			</div>

			<div class="card_footer m-t-20" v-if="editTag">
				<el-button size="small" type="primary" @click="saveUserQYInfo()">保 存</el-button>
				<el-button size="small" @click="cancel()">取 消</el-button>
			</div>
		</el-card>

		<!--  重置密码  -->
		<el-dialog title="重置密码" :visible.sync="resetPasswordDialog" :close-on-click-modal="false" width="600px" v-dialogDrag>
			<forgotPasswordCom
				v-if="resetPasswordDialog"
				:address="address"
				:smsType="'UPDATE_PWD'"
				:phone="UserInfo.phoneNumber"
				@forgotPasswordSuccess="forgotPasswordSuccessFn()"
			></forgotPasswordCom>
		</el-dialog>
		<!--  更换手机号  -->
		<el-dialog title="更换手机号码" :visible.sync="changePhoneDialog" :close-on-click-modal="false" width="600px" v-dialogDrag>
			<changePhoneCom v-if="changePhoneDialog" :phone="UserInfo.phoneNumber" @changePhoneSuccess="changePhoneSuccess()"> </changePhoneCom>
		</el-dialog>
	</div>
</template>

<script>
import forgotPasswordCom from '@/components/DialogComponent/forgotPasswordEdit'
import changePhoneCom from '@/components/DialogComponent/changePhone'
import functionCom from '@/utils/function'

export default {
	name: 'information',
	// import引入的组件需要注入到对象中才能使用
	components: {
		forgotPasswordCom,
		changePhoneCom
	},
	data() {
		// 这里存放数据
		return {
			loading: true,
			editTag: false,
			resetPasswordDialog: false,
			changePhoneDialog: false,
			UserInfo: {},
			userName: '',
			address: '',
			base64img: '',
			accountType: {
				1: '个人账号',
				2: '企事业单位',
				3: '政府单位'
			},
			provinceOptions: [],
			cityOptions: [],
			companyNatureList: [
				{ value: '国有企业', label: '国有企业' },
				{ value: '公私合营企业', label: '公私合营企业' },
				{ value: '中外合资企业', label: '中外合资企业' },
				{ value: '社会组织机构', label: '社会组织机构' },
				{ value: '国际组织机构', label: '国际组织机构' },
				{ value: '外资企业', label: '外资企业' },
				{ value: '集体企业', label: '集体企业' },
				{ value: '国防军事企业', label: '国防军事企业' },
				{ value: '事业单位', label: '事业单位' },
				{ value: '高等院校', label: '高等院校' },
				{ value: '国家行政机关', label: '国家行政机关' }
			]
		}
	},
	// 生命周期 - 创建完成（可以访问当前this实例）
	created() {
		var that = this
		setTimeout(() => {
			that.UserInfo = JSON.parse(JSON.stringify(that.$store.state.user.userInfo))
			that.userName = that.UserInfo.username
			that.address = that.$const.common.updatePwd2
			this.UserInfo.registerIdentity = 1 //默认用户类型为用户 1    其他的有 企事业单位 2 政府 3
			that.loading = false
			this.getprovinceOptions()
		}, 800)
	},
	// 方法集合
	methods: {
		provinceSelect(e) {
			console.log(111, e)
			this.provinceOptions.forEach((item) => {
				if (item.adminCode == e) {
					this.UserInfo.provinceName = item.name
				}
			})
			this.UserInfo.cityCode = ''
			this.UserInfo.cityName = ''
			this.getcityOptions()
		},
		citySelect(e) {
			this.cityOptions.forEach((item) => {
				if (item.adminCode == e) {
					this.UserInfo.cityName = item.name
				}
			})
		},
		async getprovinceOptions() {
			try {
				let res = await this.$http.get(this.$const.common.provinceUrl, {})
				if (res && res.code === 200) {
					this.provinceOptions = res.data
					this.getcityOptions()
				}
			} catch (error) {
				// console.log(error);
			}
		},
		async getcityOptions() {
			try {
				let res = await this.$http.get(this.$const.common.cityUrl + '?provinceCode=' + this.UserInfo.provinceCode, {})
				if (res && res.code === 200) {
					this.cityOptions = res.data
				}
			} catch (error) {
				// console.log(error);
			}
		},
		/*
		 * @name: 保存个人信息
		 * @description:
		 * @author: KING
		 * @time: 2022-09-23 17:26:49
		 */
		async saveUserInfo() {
			let data = {
				nickName: this.UserInfo.nickName, //	统一社会信用代码
				company: this.UserInfo.company, //公司名称
				// id: this.UserInfo.id,
				email: this.UserInfo.email, //	机构地址
				phoneNumber: this.UserInfo.phoneNumber, //机构码
				identityCard: this.UserInfo.identityCard //	机构名称
			}
			console.log(data)
			// let res = await this.$http.put(this.$const.common.setUserInfo, this.UserInfo)
			let res = await this.$http.put(this.$const.common.setUserInfo2, data)
			if (res && res.code === 200) {
				await this.$message.success(this.$PubText.saveSuccessCom)
				this.editTag = false
				await this.$store.dispatch('user/getUserINFO', {})
			}
		},
		/*
		 * @name: 保存企业信息
		 * @description:
		 * @author: Loong baba
		 * @time: 2022-010-21 17:26:49
		 */
		async saveUserQYInfo() {
			// console.log(this.UserInfo);
			// return false
			let data = {
				companyLicenseCode: this.UserInfo.companyLicenseCode, //	统一社会信用代码
				companyName: this.UserInfo.companyName, //公司名称
				id: this.UserInfo.id,
				organizationAddress: this.UserInfo.organizationAddress, //	机构地址
				organizationCode: this.UserInfo.organizationCode, //机构码
				organizationName: this.UserInfo.organizationName, //	机构名称
				type: this.UserInfo.registerIdentity,
				portrait: this.UserInfo.portrait,
				realName: this.UserInfo.realName //用户昵称
			}

			try {
				let res = await this.$http.put(this.$const.common.setUserQYInfo, data)
				if (res && res.code === 200) {
					// console.log(res);
					await this.$message.success(this.$PubText.saveSuccessCom)
					this.editTag = false
					await this.$store.dispatch('user/getUserINFO', {})
				}
			} catch (error) {
				// console.log(error);
			}
		},
		cancel() {
			this.editTag = false
			this.UserInfo = JSON.parse(JSON.stringify(this.$store.state.user.userInfo))
			this.UserInfo.registerIdentity = 1 //默认用户类型为用户 1    其他的有 企事业单位 2 政府 3
		},
		forgotPasswordSuccessFn() {
			this.resetPasswordDialog = false
			this.$message.success('重置密码成功！')
			// this.$router.push({ path: `/login?redirect=${this.$route.path}` });
			this.$store.dispatch('user/loginOut', {})
		},
		changePhoneSuccess() {
			this.$store.dispatch('user/getUserINFO', {})
		},
		// 上传成功
		upLoadFileSuccess(response, file, fileList) {
			// console.log(response,file,fileList);
			if (response.code == 200) {
				this.$message.success(this.$PubText.upLoadFileSuccess)
				this.UserInfo.portrait = response.data
			} else {
				this.$message.error(this.$PubText.upLoadFileError)
			}
		},
		// 上传失败
		upLoadFileError(err, file, fileList) {
			// console.log(err, file, fileList);
			this.$message.error(this.$PubText.upLoadFileError)
		},
		// 上传限制提示
		beforeAvatarUpload(file) {
			functionCom.beforeAvatarUpload(file)
		},
		changeRegister() {
			this.$confirm('请选择想更改的企业类型', '提示', {
				confirmButtonText: '企事业单位',
				cancelButtonText: '政府单位',
				type: 'warning',
				center: true
			})
				.then(() => {
					this.$store.dispatch('user/getUserINFO', {})
					this.UserInfo.registerIdentity = 2
					this.editTag = true
				})
				.catch(() => {
					this.$store.dispatch('user/getUserINFO', {})
					this.UserInfo.registerIdentity = 3
					this.editTag = true
				})
		}
	}
}
</script>

<style lang="scss" scoped>
.box-card {
	/deep/ .image-slot {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		background: #f5f7fa;
		color: #909399;
		font-size: 14px;

		i {
			font-size: 24px;
		}
	}

	/deep/ .el-descriptions-item__container {
		display: flex;
		align-items: center;
	}

	/deep/ .el-input {
		input {
			width: 230px;
		}
	}

	.card_footer {
		padding: 10px 20px;
		border-top: 1px solid #ebeef5;
		box-sizing: border-box;
	}

	.avatar-uploader {
		flex: 1;
		display: flex;
		align-self: flex-end;
		margin-left: 20px;
	}
}
</style>
